exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!../../../../public/css/custom.css"), "");

// module
exports.push([module.id, ".multiselect__input{pointer-events:auto}", ""]);

// exports
